import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get () {
    return ApiService.get('user/get-total-voucher-per-year')
  }
}

export default DashboardService
